import * as React from 'react';
import { View, Text, Modal } from 'react-native';
import { Icon } from 'react-native-elements';
import { CheckBox } from 'react-native-elements/dist/checkbox/CheckBox';
import { styles } from 'styles/components/orderDeliveryActionMenu';
import OrderDeliveryActionMenuProps from 'types/components/OrderDeliveryActionMenuProps';
import { useTranslation } from 'react-i18next';

export default ({
  handleFilter,
  visible,
  setVisible,
  selectedCheckbox,
  setSelectedCheckbox,
  isMediumScreen,
}: OrderDeliveryActionMenuProps): JSX.Element => {
  const renderModal = (): JSX.Element => {
    const { t } = useTranslation();
    return (
      <View style={isMediumScreen ? styles.modalContentLarge : styles.modalContentSmall}>
        <View style={styles.closeIconContainer}>
          <Icon
            name="close"
            type="ionicon"
            color={'#001639'}
            size={30}
            onPress={() => {
              setVisible(false);
            }}
          />
        </View>
        {isMediumScreen && (
          <View style={styles.titleContainer}>
            <Text style={styles.textTitle}>{t('delivery')}</Text>
            <Text style={styles.textTitleArrow}>↑</Text>
          </View>
        )}
        <View style={[styles.checkBoxOutsideContainer, { marginBottom: isMediumScreen ? 5 : 0 }]}>
          <CheckBox
            center={true}
            title={'Delivery'}
            textStyle={{
              fontSize: 14,
              fontWeight: '400',
              lineHeight: 24,
              letterSpacing: 0,
              textAlign: 'left',
              color: '#001639',
            }}
            checkedColor={'#001639'}
            uncheckedColor={'#001639'}
            checked={selectedCheckbox === 'Delivery'}
            onPress={() => {
              if (selectedCheckbox === 'Delivery') {
                setSelectedCheckbox('');
                handleFilter('');
              } else {
                setSelectedCheckbox('Delivery');
                handleFilter('Delivery');
              }
            }}
            containerStyle={styles.checkBoxInsideContainer}
          />
        </View>
        <View style={[styles.checkBoxOutsideContainer, { marginBottom: isMediumScreen ? 5 : 0 }]}>
          <CheckBox
            center={true}
            title={t('pickup')}
            textStyle={{
              fontSize: 14,
              fontWeight: '400',
              lineHeight: 24,
              letterSpacing: 0,
              textAlign: 'left',
              color: '#001639',
            }}
            checked={selectedCheckbox === 'Pickup'}
            checkedColor={'#001639'}
            uncheckedColor={'#001639'}
            onPress={() => {
              if (selectedCheckbox === 'Pickup') {
                setSelectedCheckbox('');
                handleFilter('');
              } else {
                setSelectedCheckbox('Pickup');
                handleFilter('Pickup');
              }
            }}
            containerStyle={styles.checkBoxInsideContainer}
          />
        </View>
      </View>
    );
  };

  return (
    <Modal visible={visible} transparent={true} style={styles.modal}>
      <View style={styles.container}></View>
      <View style={styles.modalBox}>{renderModal()}</View>
    </Modal>
  );
};
